/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { StyleSheet, View, ScrollView, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import { isWeb, fullWidth, fullHeight } from '@global/screens';
import Colors from '@global/colors';
import { currency } from '@global/helpers';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import Image from '@components/global/Image';
// import ProductItem from '@components/global/ProductItem';
import SociollaText from '@components/sociolla/SociollaText';
import SelectProductTable from '@components/form/SelectProductTable';

import { MsCatalog } from '@api/ms-catalog';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import { convertProductMarketType } from '@global/helpers';

const imageSize = 40;
const trash = {
  width: 12,
  height: 15,
};

const submitStyle = {
  ...(isWeb
    ? {
        width: isWeb ? 'calc(100% - 30px)' : fullWidth - 30,
      }
    : { width: fullWidth - 30 }),
  marginHorizontal: 15,
};

const ProductSectionForm = ({
  id,
  sectionId = '',
  editData = null,
  show,
  onClose,
  onSubmit,
  onAdd,
}) => {
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [addProduct, setAddProduct] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted && show) {
      if (editData) {
        const result = [];
        if (editData?.length) {
          for (let i = 0; i < editData.length; i++) {
            const item = editData[i].product;
            if (!item.image && item?.combination?.image) {
              item.image = item.combination.image;
            }
            result.push(item);
          }
        }
        setProducts(result);
      } else {
        setProducts([]);
      }
      setAddProduct(false);
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  const onSubmitForm = async () => {
    try {
      // const body = {
      //   image_column: payload.image_column,
      //   image: payload.image
      // };
      // const createData = await MsCatalog.createCMSSection(
      //   id,
      //   'images',
      //   body,
      // );
      // if (createData?.data?.data?._id) {
      // 	dispatch(showPopup({ name: 'isLoading', value: false }));
      onSubmit();
      // } else {
      // 	dispatch(showPopup({ name: 'isLoading', value: false }));
      // 	Toast.show({ text1: 'A system error occurred', type: 'error' });
      // }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const onSelectProduct = async (data) => {
    try {
      dispatch(showPopup({ name: 'isLoading', value: true }));
      const response = await MsCatalog.createCMSSection(id, 'products', {
        product_id: data.id,
        combination_id: data.product_combination_id,
        price: data.price,
      });

      if (response?.data?.data?._id || response?.data?.success) {
        const newProduct = JSON.parse(JSON.stringify(products));
        newProduct.push(convertProductMarketType(data));
        setProducts(newProduct);
        setAddProduct(false);
        onAdd();
        Toast.show({
          text1: 'Successfully added product',
          type: 'success',
        });
      } else {
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
      dispatch(showPopup({ name: 'isLoading', value: false }));
    } catch (err) {
      console.log('err', err);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: err?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  const onRemoveProduct = (data) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Remove Product',
        description: 'This product will be deleted. Do you want to proceed?',
        onCallback: async () => {
          try {
            dispatch(showPopup({ name: 'isLoading', value: true }));
            const response = await MsCatalog.deleteCMSSection(
              id,
              'products',
              data.id,
              data?.combination?.id
                ? data.combination?.id
                : data.product_combination_id,
            );
            if (response?.data?.data?._id) {
              const newProduct = JSON.parse(JSON.stringify(products));
              const idx = newProduct.findIndex((item) => item.id == data.id);
              if (idx > -1) {
                newProduct.splice(idx, 1);
                setProducts(newProduct);
                Toast.show({
                  text1: 'Successfully removed product',
                  type: 'success',
                });
              }
            } else {
              Toast.show({ text1: 'A system error occurred', type: 'error' });
            }
            dispatch(showPopup({ name: 'isLoading', value: false }));
          } catch (err) {
            dispatch(showPopup({ name: 'isLoading', value: false }));
            Toast.show({
              text1: err?.response?.data?.message || 'A system error occurred',
              type: 'error',
            });
          }
        },
      }),
    );
  };

  return (
    <ModalFull
      title="Add Product Section"
      show={show}
      back={isWeb ? false : true}
      width={isWeb ? 350 : '100%'}
      onClose={() => onClose()}>
      <ScrollView style={{ width: '100%', maxHeight: fullHeight - 140 }}>
        <View style={{ width: '100%', padding: isWeb ? 15 : 20 }}>
          {!products?.length ? (
            <View
              style={{
                paddingVertical: 20,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Image
                style={{ width: 30, height: 35 }}
                width={30}
                height={35}
                source={require('@assets/img/icons/no-product.svg')}
                svg
              />
              <SociollaText style={{ marginVertical: 10 }}>
                No product found
              </SociollaText>
              <Button
                type="default"
                rounded
                buttonStyle={{ width: 150, marginBottom: 10 }}
                disabledStyle={{ width: 150, marginBottom: 10 }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.black,
                    }}>
                    Add Product
                  </SociollaText>
                }
                onPress={() => setAddProduct(true)}
              />
            </View>
          ) : (
            products.map((item, idx) => (
              <View
                key={idx}
                style={{
                  flexDirection: 'row',
                  borderBottomColor: Colors.grey0,
                  borderBottomWidth: 1,
                  paddingVertical: 10,
                }}>
                <View style={styles.imageWrapper}>
                  <Image
                    style={{ width: imageSize, height: imageSize }}
                    width={imageSize}
                    height={imageSize}
                    source={item.image}
                  />
                </View>
                <View
                  style={{
                    width: isWeb ? 'calc(100% - 45px)' : fullWidth - 80,
                  }}>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <SociollaText
                      type="medium"
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      style={{
                        maxWidth: isWeb ? 'calc(100% - 45px)' : fullWidth - 130,
                        fontSize: 14,
                      }}>
                      {item?.reference
                        ? `[${item.reference}] `
                        : item?.sku
                        ? `[${item.sku}] `
                        : ``}
                    </SociollaText>
                    <TouchableOpacity
                      style={{
                        width: 30,
                        height: 13,
                        justifyContent: 'flex-end',
                      }}
                      activeOpacity={0.6}
                      onPress={() => onRemoveProduct(item)}>
                      <Image
                        style={{
                          width: trash.width,
                          height: trash.height,
                          alignSelf: 'flex-end',
                          marginRight: 10,
                        }}
                        width={trash.width}
                        height={trash.height}
                        source={require('@assets/img/icons/trash-grey.svg')}
                        svg={true}
                      />
                    </TouchableOpacity>
                  </View>
                  <SociollaText
                    style={{
                      fontSize: 13,
                      color: Colors.grey1,
                      marginVertical: 5,
                    }}>
                    {item?.brand?.name ? item.brand.name : '-'} - {item.name}
                  </SociollaText>
                  <SociollaText style={{ fontSize: 14 }}>
                    {currency(item.price, true)}
                  </SociollaText>
                </View>
              </View>
            ))
          )}
        </View>
        <View
          style={{
            width: '100%',
            paddingVertical: 15,
            justifyContent: 'center',
            borderTopColor: isWeb ? 'transparent' : Colors.grey0,
            borderTopWidth: 1,
          }}>
          {products?.length ? (
            <View style={{ marginBottom: 10 }}>
              <Button
                type="default"
                rounded={true}
                buttonStyle={submitStyle}
                disabledStyle={submitStyle}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.black,
                    }}>
                    Add Product
                  </SociollaText>
                }
                onPress={() => setAddProduct(true)}
              />
            </View>
          ) : (
            false
          )}
          <View>
            <Button
              rounded={true}
              buttonStyle={submitStyle}
              disabledStyle={submitStyle}
              disabled={!products?.length}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.white,
                  }}>
                  Add
                </SociollaText>
              }
              onPress={() => onSubmitForm()}
            />
          </View>
        </View>
      </ScrollView>
      <SelectProductTable
        show={addProduct}
        onClose={() => setAddProduct(false)}
        onCallback={(val) => onSelectProduct(val)}
      />
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  imageWrapper: {
    backgroundColor: Colors.white,
    justifyContent: 'center',
    marginRight: 10,
    overflow: 'hidden',
    width: imageSize,
    height: imageSize,
  },
});

export default ProductSectionForm;
